import {Component, OnInit, signal} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {CommonModule} from '@angular/common';
import {Apollo} from 'apollo-angular';
import {ProcessService} from '../../services/process.service';
import {ContextService} from '../../services/context.service';
import {JOIN_CRD_SESSION} from '../../queries-repository';
import {RepositoryProcessPayload} from '../../types-repository';

@Component({
  selector: 'app-crd-join',
  templateUrl: './crd-join.component.html',
  styleUrls: ['./crd-join.component.scss'],
  imports: [CommonModule],
})
export class CrdJoinComponent implements OnInit {
  status = signal<string>('Setting up session...');
  error = signal<string | null>(null);

  readonly pool: string;
  readonly hostId: string;
  readonly hostName: string;
  readonly monitor: number;
  readonly region: string;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private apollo: Apollo,
    private processService: ProcessService,
    private contextService: ContextService,
  ) {
    this.pool = this.route.snapshot.paramMap.get('pool') || '';
    this.hostId = this.route.snapshot.paramMap.get('hostId') || '';
    this.region = this.route.snapshot.queryParamMap.get('region') || '';
    this.monitor = parseInt(this.route.snapshot.queryParamMap.get('monitor') || '0', 10);
    this.hostName = this.route.snapshot.queryParamMap.get('hostName') || this.hostId;
  }

  ngOnInit() {
    this.startJoin();
  }

  private startJoin() {
    this.error.set(null);
    this.status.set('Setting up session...');

    this.apollo.mutate({
      mutation: JOIN_CRD_SESSION,
      variables: {input: {pool: this.pool, hostInstance: this.hostId, region: this.region, monitor: this.monitor}},
    }).subscribe({
      next: (result) => {
        const process = (result.data as any)?.joinCrdSession as RepositoryProcessPayload;
        if (!process?.id) {
          this.error.set('Failed to start join process');
          return;
        }
        this.processService.observeProcess(process, {
          failureMessage: `Failed to join session on ${this.hostName}`,
        }).subscribe({
          next: (p) => {
            if (p.state === 'SUCCESS' && p.data) {
              let parsed: any = p.data;
              while (typeof parsed === 'string') parsed = JSON.parse(parsed);
              const orgId = this.contextService.organization()?.id;
              this.router.navigate(
                ['/o', orgId, 'crd', 'view', this.pool, this.hostId],
                {
                  replaceUrl: true,
                  queryParams: {
                    signalServerUrl: parsed.signalServerUrl,
                    session: parsed.session,
                    hostPeerId: String(parsed.hostPeerId),
                    clientPeerId: String(parsed.clientPeerId),
                    password: parsed.password,
                    hostName: this.hostName,
                    monitor: this.monitor,
                  },
                },
              );
            } else if (p.state === 'FAILED') {
              this.error.set(p.message || 'Unknown error');
            } else if (p.state === 'IN_PROGRESS') {
              this.status.set('Setting up session...');
            }
          },
        });
      },
      error: (err) => {
        this.error.set(`Failed to join session: ${err?.message || 'Unknown error'}`);
      },
    });
  }

  retry() {
    this.startJoin();
  }

  goBack() {
    const orgId = this.contextService.organization()?.id;
    this.router.navigate(['/o', orgId, 'crd']);
  }
}
